<template>
  <section class="bigScreen">
    <!-- <el-button class="reflash" @click="peckText(0)">语音播放</el-button> -->
    <p class="tittleP">
      玖龙智通管理系统『{{
        comInfoObj.com_info && comInfoObj.com_info.name
      }}』成品业务大屏
    </p>
    <img class="tittlePng" :src="tittlePng" alt="" />
    <div class="mainDiv">
      <div class="leftDiv disi">
        <div class="leftDivHead">
          <p class="leftDivHeadTitle c-fff fs36">
            总装车平台：{{ listWarehouseObj.total_parking }}个
          </p>
          <p class="stateText flexMM c-fff fs32">
            <span class="stateSizeS bg-e6c841 disi mr10"></span>
            <span
              >作业中:
              <span class="c-e6c841">{{ listWarehouseObj.in_busy }}</span>
              个</span
            >
          </p>
          <p class="stateText flexMM c-fff fs32">
            <span class="stateSizeS bg-00cece disi mr10"></span>
            <span
              >空闲中:
              <span class="c-00cece">{{ listWarehouseObj.in_idle }}</span
              >个</span
            >
          </p>
        </div>

        <div class="factoryMainDiv">
          <div>
            <div
              class="factoryDiv"
              v-for="(item, index) in listWarehouseObj.warehouse"
              :key="index + 'a'"
            >
              <p class="factoryDivTitle tac c-fff fs30">{{ item.name }}</p>
              <div class="positionDiv">
                <div
                  class="positionState"
                  v-for="(location, localtionIndex) in item.location"
                  :key="localtionIndex"
                >
                  <span
                    v-show="location.state == 0"
                    class="stateSizeB bg-00cece disi"
                  ></span>
                  <span
                    v-show="location.state == 0"
                    class="positionNum fs24 lineHide c-00cece"
                    >{{ location.name }}</span
                  >
                  <span
                    v-show="location.state == 1"
                    class="stateSizeB bg-e6c841 disi"
                  ></span>
                  <span
                    v-show="location.state == 1"
                    class="positionNum fs24 lineHide c-e6c841"
                    >{{ location.name }}</span
                  >
                </div>
              </div>
            </div>
            <div
              class="factoryDiv"
              v-for="(item, index) in listWarehouseObj.warehouse"
              :key="index + 'b'"
            >
              <p class="factoryDivTitle tac c-fff fs30">{{ item.name }}</p>
              <div class="positionDiv">
                <div
                  class="positionState"
                  v-for="(location, localtionIndex) in item.location"
                  :key="localtionIndex"
                >
                  <span
                    v-show="location.state == 0"
                    class="stateSizeB bg-00cece disi"
                  ></span>
                  <span
                    v-show="location.state == 0"
                    class="positionNum fs24 lineHide c-00cece"
                    >{{ location.name }}</span
                  >
                  <span
                    v-show="location.state == 1"
                    class="stateSizeB bg-e6c841 disi"
                  ></span>
                  <span
                    v-show="location.state == 1"
                    class="positionNum fs24 lineHide c-e6c841"
                    >{{ location.name }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightDiv disi">
        <div class="rightDivHead">
          <span class="fs32 c-00cece pr5">今日预约车次</span>
          <span class="fs60 c-fff pr20">{{
            listCarNumberObj.booking_car_number
          }}</span>
          <span class="lineColumn "></span>
          <span class="fs32 c-00cece pr5 pl20">完成率</span>
          <span class="fs60 c-fff pr20"> {{ completePrec }}% </span>
          <span class="lineColumn "></span>
          <span class="fs32 c-00cece pr5 pl20">未到厂车次:</span>
          <span class="fs60 c-fff pr20">{{
            listCarNumberObj.not_info_car_number
          }}</span>
          <span class="fs32 c-00cece pr5">正在排队:</span>
          <span class="fs60 c-fff pr20">{{
            listCarNumberObj.queuing_car_number
          }}</span>
          <span class="fs32 c-00cece pr5">正在叫号:</span>
          <span class="fs60 c-fff pr20">{{
            listCarNumberObj.call_car_number
          }}</span>
          <span class="fs32 c-00cece pr5">正在装车:</span>
          <span class="fs60 c-fff pr20">{{
            listCarNumberObj.loading_car_number
          }}</span>
          <span></span>
        </div>
        <div class="loadingDiv mainDivbr">
          <div class="loadingDivHead bg-001d4c" ref="loadingDivHead">
            <p class="fs36 c-fff" v-for="(item, index) in playObj" :key="index">
              <img class="pr10 hornPng" :src="hornPng" />
              <span>请“</span>
              <span class="fs48 c-ffda3e">{{ item.info.license_plate }}</span>
              <span>”的师傅前往“</span>
              <span class="fs36 c-ffda3e"
                >{{ item.info.warehouse_name
                }}{{ item.info.parking_space_name }}</span
              >
              <span>”办理装车业务！</span>
            </p>
            <p v-if="playObj.length == 0" class="fs36 c-fff">
              <img class="pr10 hornPng" :src="hornPng" />
              <span>暂无车辆</span>
            </p>
          </div>

          <div class="dataHead fs32 tac c-078cc8">
            <span class="sp1">排队编号</span>
            <span class="sp2">车牌号</span>
            <span class="sp3">产品线</span>
            <span class="sp4">车型</span>
            <span class="sp5">装车位置</span>
            <span class="sp6">进厂时间</span>
            <span class="sp7">排队状态</span>
          </div>

          <div class="dataDiv">
            <div>
              <div
                class="dataRow fs32 tac c-fff8"
                v-for="(item, index) in listQueueCarObj.items"
                :key="index + 'a'"
              >
                <span class="sp1 c-fff8 lineHide">{{ item.queue_code }}</span>
                <span class="sp2 c-fff8 lineHide">{{
                  item.license_plate
                }}</span>
                <span class="sp3 c-fff8 lineHide">{{
                  item.business_name
                }}</span>
                <span class="sp4 c-fff8 lineHide">
                  <!-- {{ vehicleTypeText(item.vehicle_type) }} -->
                </span>
                <span class="sp5 c-fff8 lineHide">
                  {{ item.warehouse_name }}
                  {{ item.parking_space_name }}
                </span>
                <span class="sp6 c-fff8 lineHide">
                  <!-- {{ formatTime(item.queue_begin_time) }} -->
                </span>
                <span class="sp7 lineHide">
                  <!-- {{ queueStateText(item.queue_state) }} -->
                </span>
              </div>
              <div
                class="dataRow fs32 tac c-fff8"
                v-for="(item, index) in listQueueCarObj.items"
                :key="index + 'b'"
              >
                <span class="sp1 c-fff8 lineHide">{{ item.queue_code }}</span>
                <span class="sp2 c-fff8 lineHide">{{
                  item.license_plate
                }}</span>
                <span class="sp3 c-fff8 lineHide">{{
                  item.business_name
                }}</span>
                <span class="sp4 c-fff8 lineHide">
                  <!-- {{ vehicleTypeText(item.vehicle_type) }} -->
                </span>
                <span class="sp5 c-fff8 lineHide">
                  {{ item.warehouse_name }}
                  {{ item.parking_space_name }}
                </span>
                <span class="sp6 c-fff8 lineHide">
                  <!-- {{ formatTime(item.queue_begin_time) }} -->
                </span>
                <span class="sp7 lineHide">
                  <!-- {{ queueStateText(item.queue_state) }} -->
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="otherCarDiv">
          <div class="otherCarDivL mainDivbr">
            <div class="otherCarDivLHead bg-00579c">
              <span class="c-00bcd7 fs32 mr10">已发运车次:</span>
              <span class="c-fff fs38">{{ listLeaveCarObj.count }}</span>
            </div>
            <div class="dataHead fs32 tac c-078cc8">
              <span class="osp1">车牌号</span>
              <span class="osp2">物流单位</span>
              <span class="osp3">产品线</span>
              <span class="osp4">离厂时间</span>
            </div>

            <div class="dataDivBottom">
              <div>
                <div
                  class="dataRow fs32 tac c-fff"
                  v-for="(item, index) in listLeaveCarObj.items"
                  :key="index + 'a'"
                >
                  <span class="osp1 c-fff8 lineHide">
                    {{ item.license_plate }}
                  </span>
                  <span class="osp2 c-fff8 lineHide">
                    {{ item.unit_short_name }}
                  </span>
                  <span class="osp3 c-fff8 lineHide"> </span>
                  <span class="osp4 c-fff8 lineHide"> </span>
                </div>
                <div
                  class="dataRow fs32 tac c-fff"
                  v-for="(item, index) in listLeaveCarObj.items"
                  :key="index + 'b'"
                >
                  <span class="osp1 c-fff8 lineHide">
                    {{ item.license_plate }}
                  </span>
                  <span class="osp2 c-fff8 lineHide">
                    {{ item.unit_short_name }}
                  </span>
                  <span class="osp3 c-fff8 lineHide"> </span>
                  <span class="osp4 c-fff8 lineHide"> </span>
                </div>
              </div>
            </div>
          </div>
          <div class="otherCarDivR mainDivbr">
            <div class="otherCarDivLHead bg-00579c ">
              <span class="c-00bcd7 fs32 mr10">装车后滞留车辆:</span>
              <span class="c-fff fs38">{{ listStrandedCarObj.count }}</span>
            </div>
            <div class="dataHead fs32 tac c-078cc8">
              <span class="osp1">车牌号</span>
              <span class="osp2">物流单位</span>
              <span class="osp3">产品线</span>
              <span class="osp4">离厂时间</span>
            </div>

            <div class="dataDivBottom">
              <div>
                <div
                  class="dataRow fs32 tac c-fff"
                  v-for="(item, index) in listStrandedCarObj.items"
                  :key="index + 'a'"
                >
                  <span class="osp1 c-fff8 lineHide">
                    {{ item.license_plate }}
                  </span>
                  <span class="osp2 c-fff8 lineHide">
                    {{ item.unit_short_name }}
                  </span>
                  <span class="osp3 c-fff8 lineHide"> </span>
                  <span class="osp4 c-fff8 lineHide"></span>
                </div>
                <div
                  class="dataRow fs32 tac c-fff"
                  v-for="(item, index) in listStrandedCarObj.items"
                  :key="index + 'b'"
                >
                  <span class="osp1 c-fff8 lineHide">
                    {{ item.license_plate }}
                  </span>
                  <span class="osp2 c-fff8 lineHide">
                    {{ item.unit_short_name }}
                  </span>
                  <span class="osp3 c-fff8 lineHide"> </span>
                  <span class="osp4 c-fff8 lineHide"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagebutton></pagebutton>
  </section>
</template>

<script>
import socketListStoreMixin from "@/mixins/rh/socketListStoreMixin.js";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
import socketConnetMixin from "@/mixins/rh/socketConnetMixin.js";
import pagebutton from "./pagebutton.vue"; //
import audioArr from "./vodata.js";
export default {
  data() {
    return {
      deviceId: "",
      socketConnetMixinRoom: "ROOM_LOUNGE", //socketConnetMixin 加入对应的房间
      socketConnetMixinUnGetToken: true,
      hornPng: require("./assets/img/horn.png"),
      tittlePng: require("./assets/img/tittle.png"),
      com_id: "",
      business_id: "",
      callingItems: [],
      queuingItems: [],
      missCallItems: [],
      listCarNumberObj: {
        booking_car_number: 0,
        not_info_car_number: 0,
        queuing_car_number: 0,
        call_car_number: 0,
        loading_car_number: 0
      }, //车辆统计
      listQueueCarObj: { items: [] }, //排队中车辆
      listWarehouseObj: { total_parking: 0, in_busy: 0, in_idle: 0 }, // 仓库位置
      listStrandedCarObj: {}, //滞留车辆
      listLeaveCarObj: {}, //发运车辆
      comInfoObj: {},
      AllPalyObjList: [],
      playObj: [
        {
          info: {
            license_plate: "粤AAA",
            warehouse_name: "11213",
            parking_space_name: "123213"
          }
        },
        {
          info: {
            license_plate: "粤AAA",
            warehouse_name: "11213",
            parking_space_name: "123213"
          }
        }
      ],
      AudioPaly: false,
      audioPalyList: [],
      playScrollEndIndex: 0,
      leaveAndStrandlistInterval: null, // 5分钟定时刷新 已发运车次和装车后滞留车辆
      tempaudioArr: audioArr
    };
  },
  // components: { vueSeamlessScroll, pagebutton },
  components: { pagebutton },
  mixins: [socketConnetMixin, socketListStoreMixin, socketListComputedMixin],
  async mounted() {
    /* eslint-disable no-undef */
    // apiready = () => {
    //   window.api.alert(JSON.stringify(window.api.deviceId));
    // };
  },
  watch: {
    async isJoinRoomAndMonitorEven(val) {
      if (val) {
        console.log("清空数据");
        console.log("获取业务数据");
        this.listCarNumber();
        this.listQueueCar();
        this.listWarehouse();
        this.listStrandedCar();
        this.listLeaveCar();
      } else {
        console.log("socket断开");
      }
    },
    evenQueueList(val) {
      const evenQueue = JSON.parse(val);
      console.warn("socket数据来", evenQueue);
      this.changeAllObj(evenQueue);
    },
    callingItems() {
      this.setListQueueCarObjItems();
    },
    queuingItems() {
      this.setListQueueCarObjItems();
    },
    missCallItems() {
      this.setListQueueCarObjItems();
    },
    audioPalyList(val) {
      console.log(val);
      this.peckText();
      if (val.length == 0) {
        // 播放下一个
        this.AllPalyObjList.splice(0, 1);
      }
    },
    AllPalyObjList(val) {
      if (val.length == 0) {
        return;
      }
      let data = val[0];
      // 滚动
      this.playObj = JSON.parse(JSON.stringify([data, data, data]));
      this.playScrollEndIndex = 0;
      // if (this.$refs.playObjElement) {
      //   this.$refs.playObjElement.reset();
      //   this.$refs.playObjElement._startMove();
      // }
      // 语音播放
      if (this.AudioPaly) {
        this.audioPalyList = JSON.parse(JSON.stringify([data, data, data]));
      }
    }
  },
  computed: {
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 3,
        step: 5,
        hoverStop: false
      };
    },
    optionButtom() {
      return {
        limitMoveNum: 3,
        step: 2,
        hoverStop: false
      };
    },
    businessNameText() {
      return business => {
        if (!(business instanceof Array)) {
          return "";
        }
        let businessTextArr = [];
        business.forEach(item => {
          businessTextArr.push(item.name);
        });
        let businessText = businessTextArr.join("、");
        businessText = businessText.slice(0, businessText.length - 1);
        return businessText;
      };
    },
    queueStateTextColor() {
      return state => {
        if (state == 1) {
          return "c-ffda3e";
        }
        if (state == 2) {
          return "c-f8375a";
        }
        if (state == 3) {
          return "c-1890ff";
        }
        return "";
      };
    },
    completePrec() {
      let prec = 0;
      if (this.listCarNumberObj.delivery_car_number > 0) {
        prec = parseInt(
          (this.listCarNumberObj.delivery_car_number /
            this.listCarNumberObj.booking_car_number) *
            100
        );
      }
      return prec;
    }
  },
  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.leaveAndStrandlistInterval);
    next();
  },
  created() {
    try {
      /* eslint-disable no-undef */
      this.deviceId = api && api.deviceId;
    } catch (error) {
      console.warn("deviceId error", error);
    }

    this.com_id = this.$route.query.com_id;
    this.business_id = this.$route.query.business_id;
    this.AudioPaly = this.$route.query.audio_paly == 1 ? true : false;
    this.getComInfo();
    // this.listCarNumber();
    // this.listQueueCar();
    // this.listWarehouse();
    // this.listStrandedCar();
    // this.listLeaveCar();
    // 5分钟定时刷新 已发运车次和装车后滞留车辆
    // this.leaveAndStrandlistInterval = window.setInterval(() => {
    //   this.listStrandedCar();
    //   this.listLeaveCar();
    // }, 5 * 60 * 1000);

    // 语音播放测试;
    // window.setInterval(() => {
    //   console.log("开始播放");
    //   this.peckTextTest();
    // }, 10 * 1000);
  },
  methods: {
    playScrollEnd() {
      this.playScrollEndIndex++;
      if (this.playScrollEndIndex == 2) {
        // 暂时屏蔽
        // this.$refs.playObjElement._stopMove();
      }
      console.log("playScrollEnd");
    },
    setListQueueCarObjItems() {
      this.listQueueCarObj.items = this.callingItems
        .concat(this.queuingItems)
        .concat(this.missCallItems);
      // this.$refs.listQueueCarObjElement.reset();
    },
    // 处理socket数据
    changeAllObj({ actions, data }) {
      actions.forEach(element => {
        console.log(element, data);
        // 产品线过滤
        console.log(
          "激活产品线id:" + this.business_id,
          "变更数据id：" + data.business_id
        );
        // 产品线屏幕时,只处理当前产品线的数据
        if (
          this.business_id.length > 0 &&
          data.business_id != this.business_id
        ) {
          return;
        }
        console.log("操作数据");
        // 刷新车辆汇总数
        if (element.queue == "ACTION_REFRESH_NUMBER") {
          this.listCarNumber();
        }
        // 刷新趋势
        // if (element.queue == "ACTION_REFRESH_TREND") {

        // }
        // 更新装车位
        if (
          element.queue == "ACTION_OCCUPY_WAREHOUSE" ||
          element.queue == "ACTION_RELEASE_WAREHOUSE"
        ) {
          this.listWarehouse();
        }

        // 叫号中-正在叫号
        if (element.queue == "QUEUE_CALLING") {
          let tmpCallingItems = JSON.parse(JSON.stringify(this.callingItems));
          this.callingItems = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingItems
          );
          // 放入播放队列
          this.AllPalyObjList.push(data);
        }
        // 排队中
        if (element.queue == "QUEUE_QUEUE") {
          let tmpqueuingItems = JSON.parse(JSON.stringify(this.queuingItems));
          this.queuingItems = this.reSetListBySocket(
            element.action,
            data,
            tmpqueuingItems
          );
        }
        // 叫号中-已过号
        if (element.queue == "QUEUE_PASS_CALL") {
          let tmpmissCallItems = JSON.parse(JSON.stringify(this.missCallItems));
          this.missCallItems = this.reSetListBySocket(
            element.action,
            data,
            tmpmissCallItems
          );
        }
      });
    },
    // 车辆统计
    listCarNumber() {
      this.$common
        .http({
          url: "/api/queue/summary/list_car_number",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          }
        })
        .then(res => {
          this.listCarNumberObj = res.data.data;
          // console.warn(res);
        });
    },
    // 排队中车辆
    listQueueCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_queue_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          }
        })
        .then(res => {
          // this.listQueueCarObj = res.data.data;
          let miss_call_items = res.data.data.miss_call_items;
          let queuing_items = res.data.data.queuing_items;
          let calling_items = res.data.data.calling_items;
          let response_time = res.data.data.response_time;
          miss_call_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          queuing_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          calling_items.forEach(item => {
            item.response_time = response_time;
            item.id = item.queue_id;
          });
          this.missCallItems = miss_call_items;
          this.queuingItems = queuing_items;
          this.callingItems = calling_items;
          // console.log(
          //   "排队数组",
          //   this.callingItems
          //     .concat(this.queuingItems)
          //     .concat(this.missCallItems)
          // );
          this.listStrandedCarObj.items = queuing_items;
          this.listLeaveCarObj.items = queuing_items;
          // this.listQueueCarObj.items = res.data.data.calling_items;
          // console.log("排队数组", this.listQueueCarObj.items);
          //
        });
    },
    // 仓库位置
    listWarehouse() {
      this.$common
        .http({
          url: "/api/queue/summary/list_warehouse",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          }
        })
        .then(res => {
          let listWarehouseObj = res.data.data;
          let warehouse = [];
          listWarehouseObj.warehouse.forEach(element => {
            if (element.location && element.location.length > 0) {
              warehouse.push(element);
            }
          });
          listWarehouseObj.warehouse = warehouse;
          this.listWarehouseObj = listWarehouseObj;
        });
    },
    // 滞留车辆
    listStrandedCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_stranded_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          }
        })
        .then(res => {
          console.log(res);
          // this.listStrandedCarObj = res.data.data;
        });
    },
    // 发运车辆
    listLeaveCar() {
      this.$common
        .http({
          url: "/api/queue/summary/list_leave_car",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          }
        })
        .then(res => {
          console.log(res);
          // this.listLeaveCarObj = res.data.data;
        });
    },
    getComInfo() {
      this.$common
        .http({
          url: "/api/queue/summary/com_info",
          data: {
            com_id: this.com_id,
            business_id: this.business_id
          }
        })
        .then(res => {
          this.comInfoObj = res.data.data;
        });
    },
    reflash() {
      location.reload();
    },
    // 语音播报
    peckText(index = 0) {
      if (this.audioPalyList[0] == undefined) {
        return;
      }
      let df = document.createDocumentFragment();
      let audio_arr = this.audioPalyList[0].more.calling_audio;
      if (audio_arr[index] != undefined) {
        let bs64 = "data:audio/wav;base64," + audio_arr[index];
        let sndAudio = new Audio(bs64);
        sndAudio.src = bs64;
        df.appendChild(sndAudio);
        sndAudio.playbackRate -= 0.2;
        sndAudio.addEventListener("ended", () => {
          df.removeChild(sndAudio);
          this.peckText(index + 1);
        });
        sndAudio.currentTime = 0.1;
        sndAudio.play();
      } else {
        if (this.audioPalyList.length > 0) {
          setTimeout(() => {
            this.audioPalyList.splice(0, 1);
          }, 3000);
        }
      }
    },
    // 语音播报
    peckTextTest(index = 0) {
      let df = document.createDocumentFragment();
      let audio_arr = this.tempaudioArr;
      debugger;
      console.log(audio_arr[index]);
      let bs64 = "data:audio/wav;base64," + audio_arr[index];
      let sndAudio = new Audio(bs64);
      sndAudio.src = bs64;
      df.appendChild(sndAudio);
      sndAudio.playbackRate -= 0.2;
      sndAudio.addEventListener("ended", () => {
        df.removeChild(sndAudio);
        this.peckTextTest(index + 1);
      });
      sndAudio.currentTime = 0.1;
      sndAudio.play();
    }
  }
};
</script>
<style lang="less" scoped>
@leftWidth: 380px;
@leftDivHeadpl: 40px;
.bigScreen {
  height: 100%;
  width: 100%;
  background: #00305f;
  overflow: hidden;
  .bg-00cece {
    background-color: #00cece;
  }
  .bg-e6c841 {
    background-color: #e6c841;
  }
  .bg-00579c {
    background-color: #00579c;
  }
  .bg-001d4c {
    background-color: #001d4c;
  }
  .c-00cece {
    color: #00cece;
  }
  .c-e6c841 {
    color: #e6c841;
  }
  .c-00cece {
    color: #00cece;
  }
  .c-ffda3e {
    color: #ffda3e;
  }
  .c-078cc8 {
    color: #078cc8;
  }
  .c-00bcd7 {
    color: #00bcd7;
  }
  .c-f8375a {
    color: #f8375a;
  }
  .c-1890ff {
    color: #1890ff;
  }
  .c-fff {
    color: #fff;
  }
  .c-fff8 {
    color: #ccd5df;
  }
  p {
    margin: 0;
  }
  .mr10 {
    margin-right: 10px;
  }
  .stateSizeS {
    width: 36px;
    height: 36px;
  }
  .stateSizeB {
    width: 52px;
    height: 52px;
  }
  .flexMM {
    display: flex;
    align-items: center;
  }
  .flexCRM {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .fs60 {
    font-size: 60px;
  }
  .fs56 {
    font-size: 56px;
  }
  .fs48 {
    font-size: 48px;
  }
  .fs38 {
    font-size: 38px;
  }
  .fs36 {
    font-size: 36px;
  }
  .fs32 {
    font-size: 32px;
  }
  .fs30 {
    font-size: 30px;
  }
  .fs28 {
    font-size: 28px;
  }
  .fs26 {
    font-size: 26px;
  }
  .fs24 {
    font-size: 24px;
  }
  .pr5 {
    padding-right: 5px;
  }
  .pr20 {
    padding-right: 20px;
  }
  .pl20 {
    padding-left: 20px;
  }
  .pr10 {
    padding-right: 10px;
  }
  .pl10 {
    padding-left: 10px;
  }
  .tac {
    text-align: center;
  }
  .w100 {
    width: 100%;
  }
  .tittleP {
    font-size: 42px;
    text-align: center;
    background-image: -webkit-linear-gradient(top, #24d7fc, #24d7fc, #ffffff);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: absolute;
    width: 100%;
    top: 0px;
    line-height: 84px;
  }
  .tittlePng {
    width: 100%;
  }
  .disi {
    display: inline-block;
  }
  .mainDiv {
    display: flex;
    height: calc(100% - 145px);
  }
  .leftDiv {
    width: @leftWidth;
    position: relative;
    top: -120px;
  }
  .rightDiv {
    width: calc(100% - @leftWidth);
    height: 100%;
    position: relative;
    top: -100px;
  }
  .leftDivHead {
    padding-left: @leftDivHeadpl;
  }
  .leftDivHeadTitle {
    padding-bottom: 25px;
  }
  .stateText {
    height: 35px;
    padding-bottom: 25px;
  }
  .positionDiv {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    > div {
      width: 33.3%;
    }
  }
  .positionState {
    flex: 0 0 33%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 20px;
  }
  .factoryMainDiv {
    height: calc(100% - 143px);
    overflow: hidden;
    width: 100%;
    > div {
      animation-name: rowDown;
      animation-duration: 38s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-direction: normal;
    }
  }
  .factoryDiv {
    padding-bottom: 15px;
  }
  .factoryDivTitle {
    padding-bottom: 15px;
  }
  .positionNum {
    padding-top: 5px;
    width: 100%;
    text-align: center;
    display: inline-block;
  }
  .rightDivHead {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    line-height: 45px;
  }
  .lineColumn {
    height: 100%;
    width: 2px;
    background-image: linear-gradient(
      180deg,
      #00305f 0%,
      #00d0df 47%,
      #00305f 100%
    );
  }
  .mainDivbr {
    border: 2px solid #078cc8;
    border-radius: 2px 2px 0 0;
  }
  .loadingDiv {
    margin-top: 10px;
    width: calc(100% - 30px);
    height: 60%;
    overflow: hidden;
  }

  .loadingDivHead {
    height: 79px;
    line-height: 79px;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    // transform: translate(-25%, 0px);
    // transition: all 2s ease-in 2s;
    // animation: 10s rowLeft linear infinite normal;
    // -webkit-animation: 10s rowLeft ease-in infinite normal;
    // animation: 5s rowLeft linear infinite normal;

    width: 200%;
    display: inline-block;
    animation-name: rowLeft;
    animation-duration: 38s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: normal;
    > div {
      width: 100%;
      overflow: hidden;
    }
    p {
      display: inline-block;
      align-items: center;
      justify-content: center;
      width: 1506px; // css3
      // width: 100%;
    }
  }
  .dataDiv {
    height: calc(100% - 145px);
    overflow: hidden;
    > div {
      animation-name: rowDown;
      animation-duration: 38s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-direction: normal;
    }
  }
  .dataDivBottom {
    height: calc(100% - 131px);
    overflow: hidden;
    > div {
      animation-name: rowDown;
      animation-duration: 38s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-direction: normal;
    }
  }
  .dataHead,
  .dataRow {
    display: flex;
    justify-content: space-between;
    line-height: 65px;
    .sp1 {
      width: 12%;
    }
    .sp2 {
      width: 12%;
    }
    .sp3 {
      width: 12%;
    }
    .sp4 {
      width: 12%;
    }
    .sp5 {
      width: 24%;
    }
    .sp6 {
      width: 12%;
    }
    .sp7 {
      width: 12%;
    }
    .osp1 {
      width: 25%;
    }
    .osp2 {
      width: 25%;
    }
    .osp3 {
      width: 25%;
    }
    .osp4 {
      width: 25%;
    }
  }
  .otherCarDiv {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 26px);
    margin-top: 15px;
    height: 36%;
  }
  .otherCarDivR {
    width: calc(50% - 10px);
    box-sizing: border-box;
  }
  .otherCarDivL {
    width: calc(50% - 10px);
    box-sizing: border-box;
  }
  .otherCarDivLHead {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    line-height: 64px;
  }
  .lineHide {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @keyframes rowLeft {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(-50%, 0);
    }
  }
  @keyframes rowDown {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(0, -50%);
    }
  }
}
</style>
<style lang="less">
.reflash {
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  z-index: 10;
}
</style>
